import { render, staticRenderFns } from "./PortalDate.vue?vue&type=template&id=a1132f92&"
import script from "./PortalDate.vue?vue&type=script&lang=ts&"
export * from "./PortalDate.vue?vue&type=script&lang=ts&"
import style0 from "./PortalDate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports